import { memo, ReactNode } from 'react';
import { Slider as RACSlider, SliderProps as RACSliderProps, SliderThumb, SliderTrack } from 'react-aria-components';

import { OmitChildren } from '@/utils';

export type SliderProps = OmitChildren<RACSliderProps> & {
  children?: ReactNode;
};

const ISlider = ({ children, ...rest }: SliderProps) => {
  return (
    <RACSlider aria-label="slider" {...rest}>
      {children}
      <SliderTrack className="relative h-2 w-full">
        {({ state }) => (
          <>
            {/* track */}
            <div className="h-sm absolute top-[50%] w-full translate-y-[-50%] rounded-full bg-gray-200" />
            {/* fill */}
            <div
              className="bg-primary-600 h-sm absolute top-[50%] translate-y-[-50%] rounded-full"
              style={{ width: state.getThumbPercent(0) * 100 + '%' }}
            />
            <SliderThumb className="border-primary-600 top-[50%] size-4 rounded-full border bg-white transition outline-none" />
          </>
        )}
      </SliderTrack>
    </RACSlider>
  );
};

export const Slider = memo(ISlider) as typeof ISlider;
